import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import toast from 'react-hot-toast';
import { FiSave } from 'react-icons/fi';
import LoadingSpinner from '../components/LoadingSpinner';

const CreateClassroom = () => {
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (data) => {
    setSubmitting(true);
    try {
      const response = await axios.post('/api/classrooms', data);
      toast.success(`Classroom created! Code: ${response.data.classroom.code}`);
      navigate(`/classrooms/${response.data.classroom._id}`);
    } catch (error) {
      toast.error('Failed to create classroom');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Create New Classroom</h1>

      <div className="card">
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Classroom Name
            </label>
            <input
              {...register('name', { required: 'Classroom name is required' })}
              type="text"
              className="input-field"
              placeholder="Enter classroom name"
            />
            {errors.name && (
              <p className="mt-1 text-sm text-red-600">{errors.name.message}</p>
            )}
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h3 className="text-sm font-medium text-blue-900 mb-2">Note:</h3>
            <ul className="text-sm text-blue-800 space-y-1">
              <li>• A unique 6-digit code will be generated automatically</li>
              <li>• Share this code with students to allow them to join</li>
              <li>• You can add quizzes to the classroom after creation</li>
              <li>• Students can only join using the classroom code</li>
            </ul>
          </div>

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={() => navigate('/classrooms')}
              className="btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="btn-primary flex items-center"
            >
              {submitting ? (
                <LoadingSpinner size="small" />
              ) : (
                <>
                  <FiSave className="mr-2" />
                  Create Classroom
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateClassroom;